(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-blog-highlights"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-blog-carousel')) {
    class HomeBlogCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = this.querySelector('[data-carousel-dots]');

        if (!this.track || !this.previousButton || !this.nextButton || !this.dots) return;

        this.onScroll = () => this.updateControls();
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.previousButton.addEventListener('click', this.onPrevious);
        this.nextButton.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.track);
        this.refresh();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      refresh() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const articles = this.track.querySelectorAll('[data-carousel-item]');
        const firstOffset = articles[0]?.offsetLeft || 0;
        const positions = [0];

        articles.forEach((article) => {
          const position = Math.min(maxScroll, Math.max(0, article.offsetLeft - firstOffset));
          if (positions.every((existing) => Math.abs(existing - position) > 2)) positions.push(position);
        });

        if (maxScroll > 1 && positions.every((position) => Math.abs(position - maxScroll) > 2)) {
          positions.push(maxScroll);
        }

        this.positions = positions.sort((a, b) => a - b);
        const hasOverflow = maxScroll > 1 && this.positions.length > 1;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.dots.hidden = !hasOverflow;

        this.dots.replaceChildren(...this.positions.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'home-blog-highlights__dot';
          dot.setAttribute('aria-label', `Go to article position ${index + 1}`);
          dot.addEventListener('click', () => this.scrollToIndex(index));
          return dot;
        }));

        this.updateControls();
      }

      currentIndex() {
        return this.positions.reduce((nearest, position, index) =>
          Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[nearest] - this.track.scrollLeft)
            ? index
            : nearest, 0);
      }

      updateControls() {
        if (!this.positions?.length) return;
        const current = this.currentIndex();
        this.previousButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
        this.dots.querySelectorAll('button').forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === current));
        });
      }

      move(direction) {
        this.scrollToIndex(Math.max(0, Math.min(this.positions.length - 1, this.currentIndex() + direction)));
      }

      scrollToIndex(index) {
        this.track.scrollTo({
          left: this.positions[index],
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('home-blog-carousel', HomeBlogCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-protocol-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-protocol-carousel')) {
    class HomeProtocolCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = this.querySelector('[data-carousel-dots]');

        if (!this.track || !this.previousButton || !this.nextButton || !this.dots) return;

        this.onScroll = () => this.updateControls();
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.previousButton.addEventListener('click', this.onPrevious);
        this.nextButton.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.track);
        this.refresh();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      refresh() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const cards = this.track.querySelectorAll('.home-protocol-products__card');
        const firstCardOffset = cards[0]?.offsetLeft || 0;
        const positions = [0];

        cards.forEach((card) => {
          const position = Math.min(maxScroll, Math.max(0, card.offsetLeft - firstCardOffset));
          if (positions.every((existing) => Math.abs(existing - position) > 2)) positions.push(position);
        });

        if (maxScroll > 1 && positions.every((position) => Math.abs(position - maxScroll) > 2)) {
          positions.push(maxScroll);
        }

        this.positions = positions.sort((a, b) => a - b);
        const hasOverflow = maxScroll > 1 && positions.length > 1;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.dots.hidden = !hasOverflow;

        this.dots.replaceChildren(...this.positions.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'home-protocol-products__dot';
          dot.setAttribute('aria-label', `Go to product position ${index + 1}`);
          dot.addEventListener('click', () => this.scrollToIndex(index));
          return dot;
        }));

        this.updateControls();
      }

      currentIndex() {
        return this.positions.reduce((nearest, position, index) =>
          Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[nearest] - this.track.scrollLeft)
            ? index
            : nearest, 0);
      }

      updateControls() {
        if (!this.positions?.length) return;
        const current = this.currentIndex();
        this.previousButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
        this.dots.querySelectorAll('button').forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === current));
        });
      }

      move(direction) {
        this.scrollToIndex(Math.max(0, Math.min(this.positions.length - 1, this.currentIndex() + direction)));
      }

      scrollToIndex(index) {
        this.track.scrollTo({
          left: this.positions[index],
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('home-protocol-carousel', HomeProtocolCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-testimonials-carousel')) {
    class VideoTestimonialsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = this.querySelector('[data-carousel-dots]');

        if (!this.track) return;

        this.onScroll = () => this.updateControls();
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);

        this.track.querySelectorAll('video').forEach((video) => {
          video.addEventListener('play', () => {
            this.track.querySelectorAll('video').forEach((other) => {
              if (other !== video) other.pause();
            });
          });
        });

        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.track);
        this.refresh();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      refresh() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const cards = this.track.querySelectorAll('.home-video-card');
        const firstCardOffset = cards[0]?.offsetLeft || 0;
        const positions = [0];

        cards.forEach((card) => {
          const position = Math.min(maxScroll, Math.max(0, card.offsetLeft - firstCardOffset));
          if (positions.every((existing) => Math.abs(existing - position) > 2)) positions.push(position);
        });

        if (maxScroll > 1 && positions.every((position) => Math.abs(position - maxScroll) > 2)) {
          positions.push(maxScroll);
        }

        this.positions = positions.sort((a, b) => a - b);
        const hasOverflow = maxScroll > 1 && this.positions.length > 1;
        if (this.previousButton) this.previousButton.hidden = !hasOverflow;
        if (this.nextButton) this.nextButton.hidden = !hasOverflow;
        if (this.dots) this.dots.hidden = !hasOverflow;

        if (this.dots && hasOverflow) {
          this.dots.replaceChildren(...this.positions.map((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'home-video-testimonials__dot';
            dot.setAttribute('aria-label', `Go to video position ${index + 1}`);
            dot.addEventListener('click', () => this.scrollToIndex(index));
            return dot;
          }));
        }

        this.updateControls();
      }

      currentIndex() {
        return this.positions.reduce((nearest, position, index) =>
          Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[nearest] - this.track.scrollLeft)
            ? index
            : nearest, 0);
      }

      updateControls() {
        if (!this.positions?.length) return;
        const current = this.currentIndex();
        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
        if (this.dots) {
          this.dots.querySelectorAll('button').forEach((dot, index) => {
            dot.setAttribute('aria-current', String(index === current));
          });
        }
      }

      move(direction) {
        this.scrollToIndex(Math.max(0, Math.min(this.positions.length - 1, this.currentIndex() + direction)));
      }

      scrollToIndex(index) {
        this.track.scrollTo({
          left: this.positions[index],
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('video-testimonials-carousel', VideoTestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
